import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../component/MotionWrapper';
import Main_Winter from '../component/Winter/Main_Winter';
import Save_Date_Fall from '../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../component/Fall/Info_Fall';
import Letter from '../component/Spring/Letter';
import Dday_Spring from '../component/Spring/Dday_Spring';
import Message_Spring from '../component/Spring/Message_Spring';
import Location_Spring from '../component/Spring/Location_Spring';
import Footer from '../component/Footer';
import Loading from '../component/Loading';
import Location_Desc from '../component/Location/Location_Desc';
import Music from '../component/Music';
import Sharing from '../component/Sharing';
import GalleryList from '../component/Gallery/GalleryList';
import CallInfo from '../component/CallInfo';
import Interview_Spring from '../component/Spring/Interview_Spring';
import AccountList2 from '../component/Account/AccountList2';
import AccountList from '../component/Account/AccountList';
import Information from '../component/Information';
import Main_Spring from '../component/Spring/Main_Spring';
import Save_Date from '../component/Save_Date';
import Info_Spring from '../component/Spring/Info_Spring';
import Info_Spring2 from '../component/Spring/Info_Spring2';
import musicFile from '../asset/music/매일 그대와.mp3';
import ParentInfo from '../component/Info/ParentInfo';


const LeeSetByeul = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "명진수♥이셋별, 결혼합니다!";
    const openDesc = "4월 26일 오후 12시 25분 헤리움웨딩홀";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/112/thumb.JPG";

    const placeTelNum = "051-943-1004";

    const lng = 129.060303359759;
    const lat = 35.151843130536;

    const parents = [
        {groom : "명남식 · 故안인순의 아들"},
        {bride : "이금하 · 구은숙의 딸"}
    ]

    const parentInfo = {
        groom: {
            dad: { name: "명남식", isDeceased: false },
            mom: { name: "안인순", isDeceased: true },
            role: "아들",
        },
        bride: {
            dad: { name: "이금하", isDeceased: false },
            mom: { name: "구은숙", isDeceased: false },
            role: "딸",
        }
    };
//     명남식 / (국화꽃표기)안인순 의 아들 명진수
// 이금하 / 구은숙 의 딸 이셋별

    const forBus = "교보생명, 경남공고, 서면, 범내골, 지오플레이스 정류장"
    const forCar = "[해운대 방면]\n황령터널 → 고가도로옆길(황령대로) → 문전교차로\n → CJ오거리 → 더샵센트럴스타 주차장\n\n[서면교차로 방면]\n범내골교차로에서 좌회전 → 지오플레이스앞에서 좌회전\n → 더샵센트럴스타 주차장"
    const forSubway = "1호선 범내골역 8번 출구\n2호선 전포역 1, 3번 출구에서 도보 5분"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // #EF8DC1
    // #edacb1
    const conceptStyle = {
        // spring 핑크B
        concept: "SPRING",
        titleColor: "#ff8faf",
        pointColor: "#ff8faf",
        btnBgColor: "#ffcfe1",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#fff5f9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const infoTitle = "마음을 같이하여 같은 사랑을 가지고\n뜻을 합하며 한마음을 품어 (빌2:2)";

    const msg1 = "하나님이 주신 삶이라는 선물을\n하루하루 예쁘게 풀어가고 싶은 사람을 만나\n평생을 함께 걸어가려 합니다.";
    const msg2 = "따뜻한 봄날, 그 어여쁜 하루에\n늘 곁에서 아껴주신 감사한 분들을 초대합니다."
    const msg3 = "그 시작의 첫걸음에 함께하시어\n축복으로 가득 채워주시면 감사하겠습니다."


    const groomAccountList = [
        {
            role: "신랑",
            name: "명진수",
            bank: "기업은행",
            accountNumber : "010-6413-1923",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FLUOTEkjB"
        }
        ,{
            role: "신랑 부",
            name: "명남식",
            bank: "국민은행",
            accountNumber : "106-21-0075-353",
            isKakao : false
        }
        // ,{
        //     role: "신랑 모",
        //     name: "김영숙",
        //     bank: "농협은행",
        //     accountNumber : "310-02-171775",
        //     isKakao :false
        // }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "이셋별",
            bank: "기업은행",
            accountNumber : "010-2434-1725",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej7oTdyay"
        }
        // ,{
        //     role: "신부 부",
        //     name: "이상근",
        //     bank: "신한은행",
        //     accountNumber : "110-192-910940",
        //     isKakao : false
        // }
        // ,{
        //     role: "신부 모",
        //     name: "마정선",
        //     bank: "신한은행",
        //     accountNumber : "110-122-146049",
        //     isKakao : false
        // }
    ]


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "명진수",
            call: "010-6413-1923"
        },
        {
            role: "신랑 부",
            name: "명남식",
            call: "010-7313-1923"
        }
        // ,{
        //     role: "신랑 모",
        //     name: "김영숙",
        //     call: "010-3427-8086"
        // }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "이셋별",
            call: "010-2434-1725"
        },
        {
            role: "신부 부",
            name: "이금하",
            call: "010-5065-6858"
        },
        {
            role: "신부 모",
            name: "구은숙",
            call: "010-7237-8222"
        }
    ]

    const interviewContent = [
        {
            question : "서로를 처음 본 순간 든 생각은?",
            groomAnswer: "너무예뻤어",
            brideAnswer: "찾았다내짝"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "설레입니다",
            brideAnswer: "두근두근해"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "사랑합니다",
            brideAnswer: "나도사랑해"
        },
        {
            question : "설레는 결혼생활 각오 한마디!",
            groomAnswer: "행복합시다",
            brideAnswer: "늘함께하자"
        },
        {
            question : "청첩장을 보고 계신 분들에게 전하고 싶은 이야기는?",
            groomAnswer: "축하해줘요",
            brideAnswer: "감사합니다"
        }
    ]


    const informationList =[
        {
            title : "신부측 피로연 안내",
            content : "25년 3월 28일 오전 11:00 ~ 오후 2:00 \n 의성중부농협 2층"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#ff8faf"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicFile}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 parents={parents} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring isAttendFromClose={true} groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"153px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <MotionWrapper initialY={50}>
                            <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                            <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    <Location_Desc forSubway={forSubway} forBus={forBus} forCar={forCar} conceptStyle={conceptStyle}/>
                    {/* <Information pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default LeeSetByeul;